import React from "react";
import Typography from "../../../designSystem/atoms/Typography";
import ContainerWrapper from "../../../designSystem/organisms/ContainerWrapper";

import Stp from "./subComponents/Stp";
import Swp from "./subComponents/Swp";
import Redeem from "./subComponents/Redeem";
import SwitchFunds from "./subComponents/SwitchFunds";

import closeIcon from "assets/nav_close.svg";
import { ORDER_DETAILS as STRINGS } from "businesslogic/strings/ordersAuth";
import { ORDER_TYPE_MAPPER } from "businesslogic/constants/ordersAuth";

const OrdersAuthLanding = ({
  orderData,
  isLoading,
  isPageLoading,
  handleBackClick,
  handleGenerateOtp,
}) => {
  return (
    <ContainerWrapper
      dataAid={STRINGS[orderData.order_type]?.dataAid}
      headerProps={{
        leftIconSrc: closeIcon,
        headerTitle: STRINGS[orderData.order_type]?.navigationHeader.title,
        subtitle: STRINGS[orderData.order_type]?.navigationHeader.subtitle,
        dataAid: STRINGS[orderData.order_type]?.navigationHeader.dataAid,
        onBackClick: handleBackClick,
        hideMenuBar: true,
      }}
      footer={{
        button1Props: {
          onClick: handleGenerateOtp,
          title: STRINGS.footer.title,
          isLoading: isLoading,
        },
      }}
      isPageLoading={isPageLoading}
    >
      <OrderDetailCards orderData={orderData} />
      <Typography
        component="p"
        variant="body5"
        color="foundationColors.content.tertiary"
        dataAid={STRINGS.note.dataAid}
        sx={{ marginTop: "24px" }}
      >
        {orderData.disclaimer}
      </Typography>
    </ContainerWrapper>
  );
};

export default OrdersAuthLanding;

const OrderDetailCards = ({ orderData }) => {
  switch (orderData.order_type) {
    case ORDER_TYPE_MAPPER.REDEEM:
      return <Redeem orders={orderData.order_details} />;
    case ORDER_TYPE_MAPPER.SWITCH:
      return <SwitchFunds orders={orderData.order_details} />;
    case ORDER_TYPE_MAPPER.STP:
      return <Stp orders={orderData.order_details} />;
    case ORDER_TYPE_MAPPER.SWP:
      return <Swp orders={orderData.order_details} />;
    default:
      return null;
  }
};
